const SYNC_SCENARIO = {
  SINGLE_VARIANT: 'singleVariant',
  CHOOSE_VARIANTS: 'chooseVariants',
  PRODUCT: 'product',
};

export default SYNC_SCENARIO;
